import { Component, OnInit, ViewEncapsulation, OnDestroy, ViewChild, ViewChildren } from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationStart, NavigationEnd } from '@angular/router';

import { Message } from 'primeng/primeng';
import { ConfirmationService } from 'primeng/api';

import { TranslateService } from 'ng2-translate';
import { Contenido } from '../../domain/Contenido';

import { BreadcrumbService } from '../../breadcrumb.service';
import { EntityManagerProvider } from '../../providers/entity-manager-provider/entity-manager-provider';
import { AuthenticationService } from '../../providers/authentication/authentication.service';
import { ServiciosWebServiceProvider } from '../../providers/web-service-service/servicios-web-service';

import * as allSettled from 'promise-all-settled';

import {
	Predicate
} from 'breeze-client';

import { Permisos, PermisosService } from '../../providers/authentication/permisos.service';
import { AppComponent } from '../../app.component';
import { Idioma } from '../../domain/Idioma';
import { IdiomaService } from '../../providers/idioma/idioma.service';
import { Exportar } from '../../service/exportar.service';
import { SortableColumn } from 'primeng/table';

// import { GeoposicionarComponent } from '../../modules/componentes.module';
import * as XLSX from 'xlsx';
import { forEach } from '@angular/router/src/utils/collection';
import { Constantes } from '../../domain/constantes';

const FILTRO_INI = JSON.stringify({
	where: {
		Titulo: '',
		estado: 3, // ACTIVO
		// expirado: new Predicate('FechaAlta', '>=', '1900-01-01'),
		Desde: '',
		Hasta: '',
		ElementoAsignado: '',
		IdAlternativo: '',
		Tipologia: '',
		Activos: false
	},
	order: 'Titulo DESC',
	top: 10,
	page: 0,
	total: 0
});
let _where;



@Component({
	templateUrl: './contenidos.component.html',
	styles: [`
        .cars-datalist ul {
            margin: 0;
            padding: 0;
        }

        @media (max-width:640px) {
            .cars-datalist .text-column {
                text-align: center;
            }
        }
    `],
	styleUrls: ['./contenidos.component.scss'],
	encapsulation: ViewEncapsulation.None,
	providers: [ConfirmationService, Exportar]
})

export class ContenidosComponent implements OnInit, OnDestroy {

	@ViewChild('dt_contenidos') dt_contenidos;
	@ViewChild('dt_destacados') dt_destacados;
	@ViewChild('pg_contenidos') pg_contenidos;
	@ViewChild('dd_tipologia') dd_tipologia;

	public EXPIRADO = 0;
	// public PROXIMO = 1;
	public EXPIRA = 2;
	public ACTIVO = 3;
	public TODOS = 4;
	public PROXIMOACT = 5;

	public filtro;
	// JSON.parse(FILTRO_INI);



	private clasesMensajesExpirados = ['ui-messages-error ui-corner-all', 'ui-messages-warning ui-corner-all', '', 'ui-messages-success ui-corner-all'];

	public tipologiasContenido = [];
	public tipologiasContenidoSeleccionada = this.tipologiasContenido[0];

	public mensajesExpirados = [
		{
			tipo: 'TODOS',
			value: 4,
			clases: [],
			label: 'Contenidos.estadoTodos'
		},

		{
			tipo: 'PROXIMOACT',
			value: 5,
			clases: [],
			label: 'Contenidos.estadoProximoAct'
		},
		{
			tipo: 'ACTIVO',
			value: 3,
			clases: ['ui-message', 'ui-corner-all', 'ui-messages-success'],
			label: 'Contenidos.estadoActivo'
		},
		/*
		{
			tipo: 'PROXIMO',
			value: 1,
			clases: ['ui-message', 'ui-messages-warning', 'ui-corner-all'],
			label: 'Contenidos.estadoProximo'
		},*/
		{
			tipo: 'EXPIRADO',
			value: 0,
			clases: ['ui-message', 'ui-messages-error', 'ui-corner-all'],
			label: 'Contenidos.estadoExpirado'
		}
	];

	public mensajesExpiradosMod = this.mensajesExpirados[2];

	public idSeleccionado;
	public tipoSeleccionado;

	public displayDialogPrioridadDestacar = false;
	public contenidosSeleccionados = [];

	public contenidosDestacar = [];
	public contenidosDestacarFiltrados = [];

	public seccionSeleccionada;
	public alaSeleccionada;
	public espacioSeleccionado;


	msgs: Message[];
	spinner: HTMLElement;
	blockUI: HTMLElement;

	public selectedNode: Contenido;
	public contenidos: Contenido[] = [];
	public contenidosFiltrados: Contenido[] = [];
	public cols: any[];
	public cols_destacar: any[];
	public cols_imprimir: any[];
	public permisos: Permisos = new Permisos();
	disableTipologia: boolean = false;
	triggerPageChange: boolean = true;

	/* IDIOMA */
	idiomas;
	idiomaSeleccionado: Idioma;
	idiomaDefecto: Idioma;
	hayTipologias: boolean;

	csvContent;
	oContenidoErroneos = [];
	oCamposErroneos = [];
	displayDialogBidi: Boolean;
	contenidoSeleccionado: Contenido;
	csvRecords: any[] = [];
	arrayBuffer: any;
	file: File;
	filelist: any[];
	idTipologiaParam: any = '';
	cargandoContenidos = false;

	constructor(
		private appComponent: AppComponent,
		private router: Router,
		private breadcrumbService: BreadcrumbService,
		private entityManager: EntityManagerProvider,
		public authService: AuthenticationService,
		public sws: ServiciosWebServiceProvider,
		private confirmationService: ConfirmationService,
		public translate: TranslateService,
		private permisosService: PermisosService,
		private idiomaService: IdiomaService,
		private route: ActivatedRoute,
		private exportador: Exportar
	) {

		this.cols = [
			{ field: 'Imagen', fieldSort: '', header: this.translate.instant('Contenidos.imagen')}, // clases: ['th-tipo-corto1']},
			{ field: 'Titulo', fieldSort: 'Titulo', header: this.translate.instant('Contenidos.titulo')}, // clases: ['th-tipo-normal'] },
			{ field: 'expirado', fieldSort: 'expirado', header: this.translate.instant('Contenidos.estado')}, // clases: ['th-tipo-corto2'] },
			{ field: 'IdAlternativo', fieldSort: 'IdAlternativo', header: this.translate.instant('Contenidos.idAlternativo')}, // clases: ['th-tipo-medio'] },
			{ field: 'TIPOLOGIA_CONTENIDO', fieldSort: 'Tipologia', header: this.translate.instant('Contenidos.tipologia')}, // clases: ['th-tipo-medio'] },
			{ field: 'ElementoAsignado', fieldSort: '', header: this.translate.instant('Contenidos.elementosasignados')}, // clases: ['th-tipo-normal'] },
			{ field: 'MostrarEdicion', fieldSort: '', header: '' }
		];
		this.cols_imprimir = [
			{ field: 'Titulo', fieldSort: 'Titulo', header: this.translate.instant('Contenidos.titulo')}, // clases: ['th-tipo-normal'] },
			{ field: 'expirado', fieldSort: 'expirado', header: this.translate.instant('Contenidos.estado')}, // clases: ['th-tipo-corto2'] },
			{ field: 'IdAlternativo', fieldSort: 'IdAlternativo', header: this.translate.instant('Contenidos.idAlternativo')}, // clases: ['th-tipo-medio'] },
			{ field: 'TIPOLOGIA_CONTENIDO', fieldSort: 'Tipologia', header: this.translate.instant('Contenidos.tipologia')}, // clases: ['th-tipo-medio'] },
			{ field: 'ElementoAsignado', fieldSort: '', header: this.translate.instant('Contenidos.elementosasignados')}, // clases: ['th-tipo-normal'] },
			{ field: 'MostrarEdicion', fieldSort: '', header: this.translate.instant('Contenidos.tituloBotonQR') }
		];
		this.cols_destacar = [
			{ field: 'Drag', header: '' },
			{ field: 'Imagen', fieldSort: '', header: this.translate.instant('Contenidos.imagen')}, //  clases: ['th-tipo-corto1']},
			{ field: 'Titulo', fieldSort: 'Titulo', header: this.translate.instant('Contenidos.titulo')}, //  clases: ['th-tipo-normal'] },
			{ field: 'IdAlternativo', fieldSort: 'IdAlternativo', header: this.translate.instant('Contenidos.idAlternativo')}, //  clases: ['th-tipo-medio'] },
			{ field: 'expirado', fieldSort: 'expirado', header: this.translate.instant('Contenidos.estado')} //  clases: ['th-tipo-corto2'] }
		];

		// this.filtro = this.authService.getFiltroContenido();
		this.filtro = this.authService.getFiltroContenido();
		// this.filtro = this.authService.setFiltro(this.filtro);
		// this.filtro.where.expirado = new Predicate('FechaAlta', '>=', '1900-01-01');


		this.breadcrumbService.setItems([
			{ label: this.translate.instant('Contenidos.contenidos') }
		]);

		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'none';

		this.blockUI = document.getElementsByClassName('blockUI')[0] as HTMLElement;
		this.blockUI.style.display = 'none';
	}

	ngOnInit() {
		const that = this;
		window.scroll(0, 0);

		const _filtroSaved = this.authService.getFiltroContenido();
		// Contenido();

		if (_filtroSaved){
			this.filtro = _filtroSaved;
		}

		this.route.queryParams
		.subscribe(params => {

			that.entityManager.getIDIOMA()
			.then(function (idiomasENTIDAD: any) {
				that.idiomas = [];
				idiomasENTIDAD.forEach(idioma => {
					if(idioma.Visible === true){
						that.idiomas.push(new Idioma(idioma));
					}
				});

				that.idiomaDefecto = that.idiomaService.getIdiomaDefecto(that.idiomas);
				that.idiomaSeleccionado = that.idiomaDefecto;

				return that.permisosService.obtenerTIPOLOGIA_CONTENIDO();

			})
			.then(function(tipologias){
				const aux = [{ Nombre: that.translate.instant('Contenidos.estadoTodos') }];
				if (tipologias) {
					that.tipologiasContenido = aux.concat(tipologias);
				}

				const _filtroSaved = that.authService.getFiltroContenido();
				that.route.params
				.subscribe( params => {

					that.hayTipologias = tipologias !== undefined && tipologias.length > 1;

					that.idTipologiaParam = params['idTipologia'];
					if (that.idTipologiaParam === undefined && _filtroSaved.where.Tipologia === undefined){
						that.tipologiasContenidoSeleccionada =  that.tipologiasContenido.find(x => x.Nombre === _filtroSaved.where.Tipologia);
					}
					else if(that.idTipologiaParam === undefined && _filtroSaved.where.Tipologia !== undefined){
						that.tipologiasContenidoSeleccionada =  that.tipologiasContenido.find(x => x.Nombre === _filtroSaved.where.Tipologia);
						that.filtro.where.Tipologia = "";
					}
					else if(that.idTipologiaParam === that.translate.instant('MenuLateral.Todos')){
						that.tipologiasContenidoSeleccionada =  that.tipologiasContenido.find(x => x.Nombre === that.idTipologiaParam);
						that.filtro.where.Tipologia = that.idTipologiaParam;
					}
					else{
						that.tipologiasContenidoSeleccionada =  that.tipologiasContenido.find(x => x.Id === that.idTipologiaParam );
						that.filtro.where.Tipologia = that.tipologiasContenidoSeleccionada.Nombre;
					}

					if (that.idTipologiaParam === that.translate.instant('MenuLateral.Todos') || that.idTipologiaParam === undefined){
						that.disableTipologia = false;
					}else{
						that.disableTipologia = true;
					}

					that.onInputSearchChange(!that.cargandoContenidos);
				});


				return true;
				// return that.loadContenido();
			})
			.then(function(estado){
				/*that.hayTipologias = tipologias !== undefined && tipologias.length > 1;*/
				that.mensajesExpiradosMod =  that.mensajesExpirados.find(x => x.value + '' === that.filtro.where.estado);
				// return that.loadContenido();
				return true;
			})
			.then(function(){
				that.onIdiomaChange({value: that.idiomaSeleccionado});
			});
		});

	}

	ngOnDestroy(): void {
		this.entityManager.RejectChanges();
	}

	comprobarPermisos() {
		const userId = this.authService.getIdUsuario();
		const that = this;
		return this.permisosService.getPermisosUsuario(userId)
		.then(function(perm: Permisos){
			that.permisos = perm;
		});
	}

	onPageChange(evento) {
		console.log(evento);

		this.filtro.page = evento.page;
		if (this.disableTipologia === true){
			this.filtro.where.Tipologia = this.tipologiasContenidoSeleccionada.Nombre;
		}
		if (this.triggerPageChange){

			this.loadContenido();
			// this.guardarfiltrado();
		}else{
			this.triggerPageChange = true;
		}
	}

	onInputSearchChange(load = true){
		_where = this.filtro.where;
		if (this.disableTipologia === true){
			this.filtro.where.Tipologia = this.tipologiasContenidoSeleccionada.Nombre;
		}
		if (load) {
			this.loadContenido();
		}
		this.guardarfiltrado();
	}
	guardarfiltrado(){
		this.authService.setFiltroContenido(this.filtro);
	}
	clearFilter(){
		console.log('Se va a limpiar el filtro');
		this.authService.resetFiltroContenido();
		this.filtro = this.authService.getFiltroContenido();
		this.mensajesExpiradosMod = this.mensajesExpirados[2];
		if (this.disableTipologia === false){
			this.tipologiasContenidoSeleccionada = this.tipologiasContenido[0];
		}

		this.loadContenido();
	}

	onSort(evento) {
		console.log(evento);
		let field = evento.field;
		if (field === 'expirado') {
			field = 'Estado';
			// 	field = 'FechaBaja';

		}
		const sentido = evento.order > 0 ? 'ASC' : 'DESC';
		const actual = field + ' ' + sentido;
		if (actual !== this.filtro.order) {
			this.filtro.order = actual;
			this.loadContenido();
		}
	}

	loadContenido(exportar?: boolean) {

		const that = this;

		// Mostramos Spinner
		this.spinner.style.display = 'inherit';
		if (this.cargandoContenidos) {
			return
		}
		this.cargandoContenidos = true;

		const columnas = [];
		const token = this.authService.getToken();

		const idEspacio = this.authService.getIdEspacio();
		const _elementoAsignado = this.filtro.where['ElementoAsignado'];
		const _titulo = this.filtro.where['Titulo'];
		const _idAlternativo =  this.filtro.where['IdAlternativo'];
		let _tipologia;

		if(this.idTipologiaParam === undefined && this.tipologiasContenidoSeleccionada === undefined){
			_tipologia =  '';
		}else if(this.idTipologiaParam === undefined && this.tipologiasContenidoSeleccionada !== undefined  && this.tipologiasContenidoSeleccionada.Nombre !== that.translate.instant('MenuLateral.Todos')){

			_tipologia =  this.tipologiasContenidoSeleccionada.Nombre;
		}else if(this.idTipologiaParam === undefined && this.tipologiasContenidoSeleccionada.Nombre === that.translate.instant('MenuLateral.Todos')){
			_tipologia =  '';
		}else if(this.idTipologiaParam === that.translate.instant('MenuLateral.Todos') && this.tipologiasContenidoSeleccionada.Nombre === that.translate.instant('MenuLateral.Todos')){
			_tipologia =  '';
		}else{
			_tipologia =  this.tipologiasContenidoSeleccionada.Nombre;
		}

		if (this.filtro.where.Tipologia === that.translate.instant('MenuLateral.Todos') || this.filtro.where.Tipologia === that.translate.instant('MenuLateral.Todos')){
			this.disableTipologia = false;
		}


		let size = 10;
		let first = this.filtro.page * size;

		if (exportar) {
			first = 0;
			size = 1000000000000;
		}

		const orderBy = this.filtro.order.split(' ')[0];
		const order = this.filtro.order.split(' ')[1];

		const _estado =  this.filtro.where.estado;
		const Desde =  this.filtro.Desde;
		const Hasta =  this.filtro.Hasta;

		let ids = [];
		const excluidos = new Array();

		that.comprobarPermisos()
		.then(() => {
			const idIdioma = this.idiomaSeleccionado.ENTIDAD.Id;
			// that.tipologiasContenidoSeleccionada = this.tipologiasContenido[0];
			if (that.permisos.Gestion_Activos === 2) {
				this.filtro.Activos = true;
				this.authService.setFiltroContenido(this.filtro);
			}

			return this.sws.wsBuscarContenidos(token, idEspacio, idIdioma, _titulo, _estado, Desde, Hasta, _idAlternativo, _tipologia, _elementoAsignado, first, size, orderBy, order, excluidos, this.filtro.Activos).toPromise()
		})
		.then(function(resp){

			ids = resp.lista;

			that.filtro.total = resp.total;

			let includes = 'FOTOS, ';
			includes = includes + 'IDIOMAS, ';
			includes = includes + 'ALAS.ALA.IDIOMAS, ';
			includes = includes + 'ESPACIOS.ESPACIO.IDIOMAS, ';
			includes = includes + 'SECCIONES.SECCION.IDIOMAS, ';
			includes = includes + 'TIPOLOGIA_CONTENIDO.IDIOMAS';

			return that.entityManager.getContenidosById(ids, includes, columnas);
		})
		.then(function (data) {
			that.contenidos = [];
			that.contenidosFiltrados = [];

			ids.forEach(id => {
				console.log(id);
			});
			// Ordenamos los contenidos segun el orsen en el que obtubimos los id ya que el breeze no nos devuelve los contenidos en el orden de los Ids
			data = data.sort(function(a, b){
				return ids.indexOf(a.Id) - ids.indexOf(b.Id);
			});
			data.forEach(cont => {
				try {
					const contenido = new Contenido().fromENTIDAD(cont);
					if (contenido.Imagen === null || contenido.Imagen === undefined || contenido.Imagen === ''){
						contenido.Imagen = that.authService.getFotoPorDefecto();
					}
					that.contenidos.push(contenido);
				}
				catch (ex) {
					that.appComponent.showError(that.translate.instant('MensajesEmergentes.MENSAJE_ERROR_CONTENIDOS_CARGAR'));
				}
			});

			that.contenidosFiltrados = that.contenidos.filter( c => c.TIPOLOGIA_CONTENIDO.VisibilidadListaContenidosWeb);
			that.dt_contenidos.reset();
			that.dt_destacados.reset();

			return true;
		})
		.then(function () {

			// Traducimos Contenidos al idioma seleccionado
			that.contenidos = that.idiomaService.traducirContenidos(that.contenidos, that.idiomaSeleccionado);

			if (exportar){
				that.exportador.exportarXLS(that.exportador.generarHojaContenidos(that.contenidos, that.idiomaSeleccionado), 'Contenidos');
			}

			// Ocultamos Spinner

			that.triggerPageChange = false;

			that.pg_contenidos.paginatorState.page = that.filtro.page;
			that.pg_contenidos.paginatorState.totalRecords = that.filtro.total;

			that.pg_contenidos.changePage(that.filtro.page);

			that.spinner.style.display = 'none';
			that.cargandoContenidos = false
		});
	}


	loadContenidoExportar() {

		const that = this;

		// Mostramos Spinner
		this.spinner.style.display = 'inherit';

		const columnas = [];
		const token = this.authService.getToken();

		const idIdioma = this.idiomaSeleccionado.ENTIDAD.Id;
		const idEspacio = this.authService.getIdEspacio();
		const _elementoAsignado = this.filtro.where['ElementoAsignado'];
		const _titulo = this.filtro.where['Titulo'];
		const _idAlternativo =  this.filtro.where['IdAlternativo'];
		let _tipologia;

		const aux = that.translate.instant('Contenidos.estadoTodos');
		if (this.tipologiasContenidoSeleccionada && this.tipologiasContenidoSeleccionada.Nombre !== aux){
			 _tipologia = this.tipologiasContenidoSeleccionada.Nombre;
		}

		/*if (this.filtro.where.Tipologia && this.translate.instant('Contenidos.estadoTodos') !== this.filtro.where.Tipologia.toString()) {
			_tipologia =  this.filtro.where['Tipologia'];
		}*/

		const first = 0;
		const size = 1000000000000;


		const orderBy = this.filtro.order.split(' ')[0];
		const order = this.filtro.order.split(' ')[1];

		const _estado =  this.filtro.where.estado;
		const Desde =  this.filtro.Desde;
		const Hasta =  this.filtro.Hasta;

		const ids = [];

		const excluidos = new Array();

		this.sws.wsBuscarContenidosExportar(token, idEspacio, idIdioma, _titulo, _estado, Desde, Hasta, _idAlternativo, _tipologia, _elementoAsignado, first, size, orderBy, order, excluidos).toPromise()
		.then(function (data) {
			that.contenidos = data;

			that.exportador.exportarXLS(that.exportador.generarHojaContenidosExportar(that.contenidos), 'Contenidos');

			that.triggerPageChange = false;

			that.pg_contenidos.paginatorState.page = that.filtro.page;
			that.pg_contenidos.paginatorState.totalRecords = that.filtro.total;

			that.pg_contenidos.changePage(that.filtro.page);

			that.spinner.style.display = 'none';
			return that.comprobarPermisos();
		});
	}

	date2String(_date: Date) {
		if (!_date){
			return '';
		}

		const _d = _date.getDate();
		const _m = _date.getMonth() + 1;
		const _y = _date.getFullYear();

		let _fd = '' + _d;
		let _fm = '' + _m;
		const _fy = '' + _y;

		if (_d < 10) {
			_fd = '0' + _d;
		}

		if (_m < 10) {
			_fm = '0' + _m;
		}

		return _fd + '/' + _fm + '/' + _fy;

	}

	addNuevoContenido() {
		if (this.hayTipologias) {
			this.router.navigate(['/contenidos/nuevo']); // , { id: undefined, entidad: undefined }]);
		}
		else{
			this.appComponent.showWarn('mensaje', this.translate.instant('Contenidos.avisonotipologia'));
		}
	}

	mostrarEditar(contenido: Contenido) {
		this.selectedNode = contenido;
		this.idSeleccionado = contenido.ENTIDAD.Id;
		this.tipoSeleccionado = contenido.ENTIDAD.constructor.name.split('_', 2)[0];
		contenido.MostrarEdicion = true;
	}

	ocultarEditar(contenido: Contenido) {
		this.selectedNode = undefined;
		this.idSeleccionado = undefined;
		contenido.MostrarEdicion = false;
	}

	editarContenido(): boolean {
		let ok = false;
		this.router.navigate(['/contenidos/editar', { id: this.idSeleccionado, entidad: this.tipoSeleccionado }]);
		ok = true;
		this.onInputSearchChange();
		this.filtro.where = _where;
		const filtrado = this.loadContenido();
		return ok;
	}

	mostrarBidi(contenido: Contenido){
		console.log('Se va a mostrar Bidi como pop-up');
		this.contenidoSeleccionado = contenido;
		// this.blockUI = document.getElementsByClassName('contenido-tabla')[0] as HTMLElement;
		this.displayDialogBidi = true;

	}
	ocultarBidi(){
		this.contenidoSeleccionado = null;
		this.displayDialogBidi = false;
	}
	eliminarContenido(contenido: Contenido) {

		this.confirmationService.confirm({
			message: this.translate.instant('MensajesConfirmacion.MENSAJE_CONFIRMACION_ELIMINAR'),
			header: this.translate.instant('MensajesConfirmacion.MENSAJE_CABECERA_CONFIRMACION'),
			icon: 'fa fa-question-circle',
			accept: () => {
				const that = this;
				// Mostramos Spinner
				this.spinner.style.display = 'inherit';
				this.entityManager.deleteCONTENIDO(contenido.ENTIDAD)
				// this.entityManager.saveChanges()
				.then(function (resp) {

					if (resp === false){
						that.appComponent.showError(that.translate.instant('MensajesEmergentes.MENSAJE_ERROR_CONTENIDOS_BORRAR'));
						return false;
					}

					that.contenidos = that.contenidos.filter((val, i) => val.ENTIDAD.Id !== contenido.ENTIDAD.Id);
					that.filtro.total--;

					that.appComponent.showSuccess(that.translate.instant('MensajesConfirmacion.MENSAJE_SUCCES'));

					if (that.contenidos.length === 0 && that.filtro.page > 0)
					{
						that.filtro.page--;

						that.pg_contenidos.paginatorState.page = that.filtro.page;
						that.pg_contenidos.paginatorState.totalRecords = that.filtro.total;

						that.pg_contenidos.changePage(that.filtro.page);
					}
					return that.loadContenido();

				})
				.then(function(){
					// Mostramos Spinner
					that.spinner.style.display = 'none';
				})
				.catch(function (e) {
					// Mostramos Spinner
					that.spinner.style.display = 'none';

					that.appComponent.showError(that.translate.instant('MensajesEmergentes.MENSAJE_ERROR_ELIMINAR_CONTENIDO'));
					console.log(e.status);
					return false;
				});
			},
			reject: () => {

			}
		});
	}

	/* FILTROS DE BUSQUEDA */
	private filtra(filter, value, col) {
		if (filter === undefined || filter === null || filter.trim() === '') {
			return true;
		}
		if (value === undefined || value === null) {
			return false;
		}
		const filterValue = filter.toString().toLowerCase().normalizar();

		const tipo = typeof value[col];

		if (tipo === 'string') {
			return value[col].toLowerCase().normalizar().indexOf(filterValue) !== -1;
		}

		const elementos = value[col].filter(function (elem) {
			return (elem.Nombre.toString().normalizar().toLowerCase().indexOf(filterValue) !== -1) || (elem.Tipo.toString().normalizar().toLowerCase().indexOf(filterValue) !== -1);
		});

		return elementos.length > 0;
	}

	filtraConjunto(filter, lista, op) {
		const that = this;

		this.contenidosFiltrados = this.contenidos.filter(function (value) {
			for (const i in lista) {
				if (that.filtra(filter, value, lista[i])) {
					return true;
				}
			}
			return false;
		});
	}

	filterGenerico(filter, col, op) {
		const that = this;
		this.loadContenido();
	}

	calculaBreezeDate(diff){
		const now = new Date();
		now.setDate(now.getDate() + diff);

		return now.getFullYear() + '/' + (now.getMonth() + 1) + '/' + now.getDate();
	}

	filterEstado(filter) {
		this.filtro.where.estado = filter.value;
		this.filtro.page = 0;
		this.guardarfiltrado();
		this.loadContenido();
	}

	filterTipologia(TIPOLOGIA_CONTENIDO){
		const valorFiltrado = TIPOLOGIA_CONTENIDO.Nombre;

		this.filtro.where.Tipologia = valorFiltrado;
		this.filtro.page = 0;
		this.guardarfiltrado();
		this.loadContenido();
	}
	getMensajesExpirados(_val) {
		//console.log(_val)
		for (const i in this.mensajesExpirados) {
			if (this.mensajesExpirados[i].value === _val) {
				return this.mensajesExpirados[i];
			}
		}
		return {};
	}

/* ******** PRIORIDAD DESTACADA ******** */
	mostrarContenidosSeccion(rowData){
		console.log('Editar: ' + rowData.Nombre);
		rowData.MostrarEdicion = true;
		if (rowData.Tipo ===  'SECCION') {
			this.seccionSeleccionada = rowData.ENTIDAD.SECCION;
		}
		if (rowData.Tipo ===  'ALA') {
			this.alaSeleccionada = rowData.ENTIDAD.ALA;
		}
		if (rowData.Tipo ===  'ESPACIO') {
			this.espacioSeleccionado = rowData.ENTIDAD.ESPACIO;
		}
	}

	ocultarContenidosSeccion(rowData){
		console.log('Dejar: ' + rowData.Nombre);
		rowData.MostrarEdicion = false;
		// this.seccionSeleccionada = {};
	}

	mostrarFormularioPrioridadDestacar(elementoAsociado){
		const that = this;

		this.alaSeleccionada = undefined;
		this.seccionSeleccionada = undefined;
		this.espacioSeleccionado = undefined;

		if (elementoAsociado.Tipo ===  'SECCION') {
			// Mostramos Spinner
			this.spinner.style.display = 'inherit';

			this.seccionSeleccionada = elementoAsociado.ENTIDAD.SECCION;

			this.contenidosSeleccionados = [];
			this.contenidosDestacar = [];

			const includes = 'CONTENIDOS.CONTENIDO';

			const predicado = new Predicate('Id', '==', this.seccionSeleccionada.Id);

			this.entityManager.getSECCION(predicado, includes)
			.then(function(secciones){
				if (secciones) {

					that.seccionSeleccionada = secciones[0];
					that.seccionSeleccionada.CONTENIDOS.forEach(content => {
						try {
							// const contenidoForm = new Contenido(content);
							const contenidoForm = new Contenido().fromENTIDAD(content.CONTENIDO);

							if (contenidoForm.Imagen === null || contenidoForm.Imagen === undefined || contenidoForm.Imagen === ''){
								contenidoForm.Imagen = that.authService.getFotoPorDefecto();
							}

							const seccion_has_contenido = contenidoForm.ENTIDAD.SECCIONES.filter(x => x.IdSeccion === that.seccionSeleccionada.Id)[0];

							if (seccion_has_contenido && seccion_has_contenido.PrioridadDestacado !== 0) {
								that.contenidosDestacar.push(contenidoForm);
							}

							that.contenidosSeleccionados.push(contenidoForm);
						}
						catch (ex) {
							that.appComponent.showError(ex);
						}

					});
					that.contenidosSeleccionados.sort( (one: any, two: any) => {
						const seccion_has_contenido_1 = one.ENTIDAD.SECCIONES.filter(x => x.IdSeccion === that.seccionSeleccionada.Id)[0];
						const seccion_has_contenido_2 = two.ENTIDAD.SECCIONES.filter(x => x.IdSeccion === that.seccionSeleccionada.Id)[0];

						return seccion_has_contenido_1.Prioridad > seccion_has_contenido_2.Prioridad ? 1 : -1;
					});

					that.displayDialogPrioridadDestacar = true;
					that.spinner.style.display = 'none';
				}

			});
		}
		if (elementoAsociado.Tipo ===  'ALA') {
			// Mostramos Spinner
			this.spinner.style.display = 'inherit';
			this.alaSeleccionada = elementoAsociado.ENTIDAD.ALA;

			this.contenidosSeleccionados = [];
			this.contenidosDestacar = [];
			const includes = 'CONTENIDOS.CONTENIDO';

			const predicado = new Predicate('Id', '==', this.alaSeleccionada.Id);

			this.entityManager.getALA(predicado, includes)
			.then(function(ala){
				that.alaSeleccionada = ala[0];
				that.alaSeleccionada.CONTENIDOS.forEach(content => {
					try {
						// const contenidoForm = new Contenido(content);
						const contenidoForm = new Contenido().fromENTIDAD(content.CONTENIDO);
						if (contenidoForm.Imagen === null || contenidoForm.Imagen === undefined || contenidoForm.Imagen === ''){
							contenidoForm.Imagen = that.authService.getFotoPorDefecto();
						}
						const ala_has_contenido = contenidoForm.ENTIDAD.ALAS.filter(x => x.IdAla === that.alaSeleccionada.Id)[0];

						if (ala_has_contenido && ala_has_contenido.PrioridadDestacado !== 0) {
							that.contenidosDestacar.push(contenidoForm);
						}

						that.contenidosSeleccionados.push(contenidoForm);
					}
					catch (ex) {
						that.appComponent.showError(ex);
					}

				});
				that.contenidosSeleccionados.sort( (one: any, two: any) => {
					const ala_has_contenido_1 = one.ENTIDAD.ALAS.filter(x => x.IdAla === that.alaSeleccionada.Id)[0];
					const ala_has_contenido_2 = two.ENTIDAD.ALAS.filter(x => x.IdAla === that.alaSeleccionada.Id)[0];

					return ala_has_contenido_1.Prioridad > ala_has_contenido_2.Prioridad ? 1 : -1;
				});
				that.displayDialogPrioridadDestacar = true;
				that.spinner.style.display = 'none';
			});
		}
		if (elementoAsociado.Tipo ===  'ESPACIO') {
			// Mostramos Spinner
			this.spinner.style.display = 'inherit';

			this.espacioSeleccionado = elementoAsociado.ENTIDAD.ESPACIO;

			this.contenidosSeleccionados = [];
			this.contenidosDestacar = [];
			const includes = 'CONTENIDOS.CONTENIDO';

			const predicado = new Predicate('Id', '==', this.espacioSeleccionado.Id);

			this.entityManager.getESPACIO(predicado, includes)
			.then(function(espacio){
				that.espacioSeleccionado = espacio[0];
				that.espacioSeleccionado.CONTENIDOS.forEach(content => {
					try {
						const contenidoForm = new Contenido().fromENTIDAD(content.CONTENIDO);
						if (contenidoForm.Imagen === null || contenidoForm.Imagen === undefined || contenidoForm.Imagen === ''){
							contenidoForm.Imagen = that.authService.getFotoPorDefecto();
						}

						const espacio_has_contenido = contenidoForm.ENTIDAD.ESPACIOS.filter(x => x.IdEspacio === that.espacioSeleccionado.Id)[0];

						if (espacio_has_contenido && espacio_has_contenido.PrioridadDestacado !== 0) {
							that.contenidosDestacar.push(contenidoForm);
						}

						that.contenidosSeleccionados.push(contenidoForm);
					}
					catch (ex) {
						that.appComponent.showError(ex);
					}

				});
				that.contenidosSeleccionados.sort( (one: any, two: any) => {
					const espacio_has_contenido_1 = one.ENTIDAD.ESPACIOS.filter(x => x.IdEspacio === that.espacioSeleccionado.Id)[0];
					const espacio_has_contenido_2 = two.ENTIDAD.ESPACIOS.filter(x => x.IdEspacio === that.espacioSeleccionado.Id)[0];

					return espacio_has_contenido_1.Prioridad > espacio_has_contenido_2.Prioridad ? 1 : -1;
				});
				that.displayDialogPrioridadDestacar = true;
				that.spinner.style.display = 'none';
			});
		}

	}

	ocultarFormularioPrioridadDestacar(){
		this.displayDialogPrioridadDestacar = false;


	}

	onMostrarFormularioPrioridadDestacar($event){

		console.log('ELEMENTO A EDITAR');

	}

	onOcultarFormularioPrioridadDestacar($event){

	}

	guardarDestacados(){
		// this.contenidosSeleccionados

		if (this.seccionSeleccionada) {
			let i = 1;
			const Destacar_aux = [];
			const ContenidosSeleccionados_aux = [];

			// this.contenidosDestacar
			this.contenidosSeleccionados.forEach(contenido => {
				const destacado = this.contenidosDestacar.filter( x => x.Id === contenido.Id)[0];
				if (destacado !== undefined) {
					const xxxxxx_has_contenido = contenido.ENTIDAD.SECCIONES.filter( x => x.IdSeccion === this.seccionSeleccionada.Id)[0];
					xxxxxx_has_contenido.PrioridadDestacado = i;
					xxxxxx_has_contenido.Prioridad = i;
					Destacar_aux.push(contenido);
					i = i + 1;
				}
			});

			i = Destacar_aux.length + 1;
			this.contenidosSeleccionados.forEach(contenido => {
				const xxxxxx_has_contenido = contenido.ENTIDAD.SECCIONES.filter( x => x.IdSeccion === this.seccionSeleccionada.Id)[0];
				const destacado = Destacar_aux.filter( x => x.Id === contenido.Id)[0];

				// No es destacado
				if (destacado === undefined) {
					xxxxxx_has_contenido.PrioridadDestacado = 0;
					ContenidosSeleccionados_aux.push(contenido);
					xxxxxx_has_contenido.Prioridad = i;
					i = i + 1;
				}
			});
		}

		if (this.alaSeleccionada){


			let i = 1;
			const Destacar_aux = [];
			const ContenidosSeleccionados_aux = [];


			this.contenidosSeleccionados.forEach(contenido => {
				const destacado = this.contenidosDestacar.filter( x => x.Id === contenido.Id)[0];
				if (destacado !== undefined) {
					const xxxxxx_has_contenido = contenido.ENTIDAD.ALAS.filter( x => x.IdAla === this.alaSeleccionada.Id)[0];
					xxxxxx_has_contenido.PrioridadDestacado = i;
					xxxxxx_has_contenido.Prioridad = i;
					Destacar_aux.push(contenido);
					i = i + 1;
				}
			});

			i = Destacar_aux.length + 1;
			this.contenidosSeleccionados.forEach(contenido => {
				const xxxxxx_has_contenido = contenido.ENTIDAD.ALAS.filter( x => x.IdAla === this.alaSeleccionada.Id)[0];
				const destacado = Destacar_aux.filter( x => x.Id === contenido.Id)[0];

				// No es destacado
				if (destacado === undefined) {
					xxxxxx_has_contenido.PrioridadDestacado = 0;
					ContenidosSeleccionados_aux.push(contenido);
					xxxxxx_has_contenido.Prioridad = i;
				i = i + 1;
				}
			});
		}

		if (this.espacioSeleccionado){


			let i = 1;
			const Destacar_aux = [];
			const ContenidosSeleccionados_aux = [];

			this.contenidosSeleccionados.forEach(contenido => {
				const destacado = this.contenidosDestacar.filter( x => x.Id === contenido.Id)[0];
				if (destacado !== undefined) {
					const xxxxxx_has_contenido = contenido.ENTIDAD.ESPACIOS.filter( x => x.IdEspacio === this.espacioSeleccionado.Id)[0];
					xxxxxx_has_contenido.PrioridadDestacado = i;
					xxxxxx_has_contenido.Prioridad = i;
					Destacar_aux.push(contenido);
					i = i + 1;
				}
			});

			i = Destacar_aux.length + 1;
			this.contenidosSeleccionados.forEach(contenido => {
				const xxxxxx_has_contenido = contenido.ENTIDAD.ESPACIOS.filter( x => x.IdEspacio === this.espacioSeleccionado.Id)[0];
				const destacado = Destacar_aux.filter( x => x.Id === contenido.Id)[0];

				// No es destacado
				if (destacado === undefined) {
					xxxxxx_has_contenido.PrioridadDestacado = 0;
					ContenidosSeleccionados_aux.push(contenido);
					xxxxxx_has_contenido.Prioridad = i;
				i = i + 1;
				}
			});

		}


		this.entityManager.saveChanges();

		this.ocultarFormularioPrioridadDestacar();

	}

	cancelarDestacados(){
		this.ocultarFormularioPrioridadDestacar();

	}


	/* IDIOMA */
	onIdiomaChange($event) {

		// Cambiamos el idioma seleccionado
		let idioma;
		if ($event === undefined) {
			idioma = this.idiomaSeleccionado ? this.idiomaSeleccionado : this.idiomaService.getIdiomaDefecto(this.idiomas);
		}
		else{
			idioma = $event.value;
		}
		if (!idioma) {
			return;
		}
		this.idiomaSeleccionado = idioma;

		// Aplicamos el filtro sobre los contenidos en el nuevo idioma
		if (this.tipologiasContenidoSeleccionada) {
			this.tipoSeleccionado =  this.idiomaService.traducirTipologiaContenido(this.tipologiasContenidoSeleccionada, this.idiomaSeleccionado);
		}
		const tipologiasContenido_aux = this.idiomaService.traducirTipologiasContenido(this.tipologiasContenido, this.idiomaSeleccionado);
		this.tipologiasContenido = tipologiasContenido_aux;
		this.tipologiasContenido = Object.assign([], this.tipologiasContenido);

		if (this.tipoSeleccionado) {
			this.filtro.where.Tipologia = this.tipoSeleccionado.Nombre;
		}

		this.loadContenido();

		console.log('Cambiar Titulo y descripcion a la del idioma: ' + idioma.value + '(' + idioma.title + ')');
	}



	exportarContenido(){
		this.loadContenidoExportar();
	}

	onFileSelectContenidos(event, fileUploadComponent) {
		this.file = event.files[0];
		const fileReader = new FileReader();
		fileReader.readAsArrayBuffer(this.file);
		fileReader.onload = (e) => {
			this.arrayBuffer = fileReader.result;
			const data = new Uint8Array(this.arrayBuffer);
			const arr = new Array();
			for ( let i = 0; i !== data.length; ++i) {
				arr[i] = String.fromCharCode(data[i]);
			}
			const bstr = arr.join('');
			const workbook = XLSX.read(bstr, {type: 'binary'});
			const first_sheet_name = workbook.SheetNames[0];
			const worksheet = workbook.Sheets[first_sheet_name];
			if (this.checkImportFile(worksheet)) {
				console.log(XLSX.utils.sheet_to_json(worksheet, {raw: true}));
				const arraylist = XLSX.utils.sheet_to_json(worksheet, {raw: true});
				this.csvContent = arraylist;
				this.preguntarImportar(fileUploadComponent);
			}
			else {
				this.csvContent = [];
				fileUploadComponent.clear();
				this.appComponent.showError(this.translate.instant('Contenidos.FicheroNoValido'));
			}
		};
	}

	checkImportFile(arg0: any): boolean {

		if (arg0.A1.v !== 'Título')
		{
			return false;
		}
		if (arg0.B1.v !== 'Texto en Plano')
		{
			return false;
		}
		if (arg0.C1.v !== 'Código')
		{
			return false;
		}
		if (arg0.D1.v !== 'Tipología')
		{
			return false;
		}
		if (arg0.E1.v !== 'Descripción')
		{
			return false;
		}
		if (arg0.F1.v !== 'Html Detalle')
		{
			return false;
		}
		if (arg0.G1.v !== 'Audioguía')
		{
			return false;
		}
		if (arg0.H1.v !== 'Alta')
		{
			return false;
		}
		if (arg0.I1.v !== 'Baja')
		{
			return false;
		}
		if (arg0.J1.v !== 'Asignado a:')
		{
			return false;
		}
		if (arg0.K1.v !== 'Situado en:')
		{
			return false;
		}
		if (arg0.L1.v !== 'Coordenadas Plano')
		{
			return false;
		}
		if (arg0.M1.v !== 'Coordenadas GPS')
		{
			return false;
		}
		/*
		if (arg0.N1.v !== 'Idioma')
		{
			return false;
		}
		*/

		return true;
	}

	preguntarImportar(fileUploadComponent){
		const that = this;
		this.confirmationService.confirm({
			message: this.translate.instant('MensajesConfirmacion.MENSAJE_CONFIRMACION_IMPORTACION'),
			accept: () => {
				fileUploadComponent.clear();
				that.importarContenido();
			},
			reject: () => {
				fileUploadComponent.clear();
				console.log('Cancelado la Importacion de Contenido.');
			}
		});
	}

	importarContenido(){
		console.log('Importar: ');

		// Mostramos Spinner
		this.spinner.style.display = 'inherit';

		const idEspacio = this.authService.getIdEspacio();

		const promises: any[] = [];
		const that = this;
		const listCONTENIDOS = [];

		this.csvContent.forEach(element => {
			promises.push(that.entityManager.newCONTENIDO());
		});

		let errors = 0;
		let mensaje;
		return allSettled(promises)
		.then(function(CONTENIDOS){
			// Título;Texto en Plano;Código;Tipología;Descripción;Html Detalle;Audioguía;Alta;Baja;Codigo de Seccion

			for (let index = 0; index < CONTENIDOS.length; index++) {
				let oContenido;

				try {
					oContenido = CONTENIDOS[index].result;
					if (that.csvContent[index]['Título'] !== ''){
						oContenido.Titulo = that.csvContent[index]['Título'];
					}
					else{
						errors++;
						oContenido.Titulo = that.csvContent[index]['Título'];
						mensaje = 'El Título de la fila ' + index + ' está sin rellenar';
						that.oCamposErroneos.push(mensaje);
						continue;
					}

					if (that.csvContent[index]['Descripción'] !== ''){
						oContenido.Descripcion =  that.csvContent[index]['Descripción'];
					}
					else{
						errors++;
						oContenido.Descripcion =  that.csvContent[index]['Descripción'];
						mensaje = 'La Descripción de la fila ' + index + ' está sin rellenar';
						that.oCamposErroneos.push(mensaje);
						continue;
					}
					if (that.csvContent[index]['Alta'] !== '' ){
						oContenido.FechaAlta = that.csvContent[index]['Alta'];
					}
					else{
						errors++;
						oContenido.FechaAlta = that.csvContent[index]['Alta'];
						mensaje = 'Las fechas de la fila ' + index + ' están sin rellenar';
						that.oCamposErroneos.push(mensaje);
						continue;
					}

					if (that.csvContent[index]['Baja'] !== ''){
						oContenido.FechaBaja = that.csvContent[index]['Baja'];
					}

					if (that.csvContent[index]['Código'] !== ''){
						oContenido.IdAlternativo = that.csvContent[index]['Código'];
					}
					else{
						errors++;
						oContenido.IdAlternativo = that.csvContent[index]['Código'];
						mensaje = 'El Código de la fila ' + index + ' está sin rellenar';
						that.oCamposErroneos.push(mensaje);
						continue;
					}
					if (that.csvContent[index]['Html Detalle'] !== ''){
						oContenido.htmlVisualizableDetalle = that.csvContent[index]['Html Detalle'];
					}
					else{
						errors++;
						oContenido.htmlVisualizableDetalle = that.csvContent[index]['Html Detalle'];
						mensaje = 'El Html Detalle de la fila ' + index + ' está sin rellenar';
						that.oCamposErroneos.push(mensaje);
						continue;
					}
					if (that.csvContent[index]['Audioguía'] !== ''){
						oContenido.AudioTexto = that.csvContent[index]['Audioguía'];
					}
					else{
						errors++;
						oContenido.AudioTexto = that.csvContent[index]['Audioguía'];
						mensaje = 'El Audioguía de la fila ' + index + ' está sin rellenar';
						that.oCamposErroneos.push(mensaje);
						continue;
					}
					if (that.csvContent[index]['Texto en Plano'] !== ''){
						oContenido.NombreCorto = that.csvContent[index]['Texto en Plano'];
					}
					else{
						errors++;
						oContenido.NombreCorto = that.csvContent[index]['Texto en Plano'];
						mensaje = 'El Texto en Plano de la fila ' + index + ' está sin rellenar';
						that.oCamposErroneos.push(mensaje);
						continue;
					}

					oContenido.EspacioPertenencia = idEspacio;
					let coord_plano;
					let coord_gps;
					if (that.csvContent[index]['Coordenadas Plano'] !== ''){
						 coord_plano = that.csvContent[index]['Coordenadas Plano'];
					}

					if (that.csvContent[index]['Coordenadas GPS'] !== ''){
						coord_gps = that.csvContent[index]['Coordenadas GPS'];
				   	}

					coord_plano = coord_plano.split(',');
					coord_gps = coord_gps.split(',');

					if (coord_plano && coord_plano.length === 2) {
						oContenido.X = Number(coord_plano[0]);
						oContenido.Y = Number(coord_plano[1]);
					}
					else {
						oContenido.X = 0;
						oContenido.Y = 0;
					}

					if (coord_gps && coord_gps.length === 2) {
						oContenido.Latitud = Number(coord_gps[0]);
						oContenido.Longitud = Number(coord_gps[1]);
					}
					else {
						oContenido.Latitud = 0;
						oContenido.Longitud = 0;
					}

					oContenido.TIPOLOGIA_CONTENIDO = that.tipologiasContenido.find(t => t.IDIOMAS && t.IDIOMAS.find( i => i.Nombre === that.csvContent[index]['Tipología']));
					oContenido.IDIOMAS.forEach(CONTENIDO_IDIOMA => {
						CONTENIDO_IDIOMA.Nombre = oContenido.Titulo;
						CONTENIDO_IDIOMA.Descripcion = oContenido.Descripcion;
						CONTENIDO_IDIOMA.htmlVisualizableDetalle = oContenido.htmlVisualizableDetalle;
						CONTENIDO_IDIOMA.AudioTexto = oContenido.AudioTexto;
						CONTENIDO_IDIOMA.NombreCorto = oContenido.NombreCorto;
					});

					listCONTENIDOS.push(oContenido);
				} catch (error) {
					that.oContenidoErroneos.push(oContenido);
				}
			}
			return that.obtenerALAS();
		})
		.then(function (alas) {
			return that.crearRelaciones(listCONTENIDOS, alas);
		})
		.then(function (datos) {
			return that.entityManager.saveChanges();
		})
		.then(function(res){
			// Ocultar Spinner
			that.spinner.style.display = 'none';

			if (errors > 0) {
				if (errors === that.csvContent.length ) {
					that.appComponent.showError(that.translate.instant('Contenidos.errorinsertarcontenidos') + errors );
				}
				else {
					that.appComponent.showWarn(that.translate.instant('Contenidos.errorinsertarcontenidos') + errors );
				}
			}
			else {
				that.appComponent.showSuccess(that.translate.instant('MensajesConfirmacion.MENSAJE_SUCCES'));
			}
		})
		.catch(function(err){

			let contenidos = '';
			that.oContenidoErroneos.forEach(element => {
				contenidos = contenidos + '<p>' + element.Titulo + '</p> ';
			});
			// Ocultar Spinner
			that.spinner.style.display = 'none';

			that.appComponent.showError(that.translate.instant('Contenidos.errorinsertarcontenidos') +  contenidos);
			console.log(err);
		});

	}
	downloadFile(fileName) {
		if (fileName === 'Plantilla_Importar_Contenido.xlsx') {
			return this.sws.downloadFile(Constantes.Guia_de_Refencia_de_exportacion, fileName);
		}
	}
	Imprimir(){
		console.log('Se va a imprimir');
		window.print();
	}
	crearRelaciones(listaContenidos, alas) {
		const that = this;
		const CONTENIDOS = listaContenidos;
		let promises: any[] = [];
		const ALAS = alas;
		let ala;
		let seccion;

		CONTENIDOS.forEach(element => {
			promises.push(this.entityManager.newSECCION_has_CONTENIDO());
		});

		return allSettled(promises)
		.then(function (listSECCION_has_CONTENIDO) {

			for (let index = 0; index < CONTENIDOS.length; index++) {

				let oContenido;
				try{
					oContenido = CONTENIDOS[index];
					const lineaContenido = that.csvContent.find( c => c['Código'] === oContenido.IdAlternativo);

					ala = ALAS.find(a => a.SECCIONS.find( s => s.IDIOMAS.find( i => i.Nombre === lineaContenido['Asignado a:'])));
					seccion = ala.SECCIONS.find( s => s.IDIOMAS.find( i => i.Nombre === lineaContenido['Asignado a:']));

					const SECCION_has_CONTENIDO = listSECCION_has_CONTENIDO[index].result;

					oContenido.IdAlaPlano = ala.Id;
					SECCION_has_CONTENIDO.IdContenido = oContenido.Id;
					SECCION_has_CONTENIDO.IdSeccion = seccion.Id;
					SECCION_has_CONTENIDO.Prioridad = seccion.CONTENIDOS.length;
				}
				catch (error) {
					that.oContenidoErroneos.push(oContenido);
				}
			}

			promises = [];
			CONTENIDOS.forEach(CONTENIDO => {
				promises.push(that.entityManager.newNODO_has_CONTENIDO());
			});

			return allSettled(promises);
		})
		.then(function (listaNODO_has_CONTENIDO) {
			for (let index = 0; index < CONTENIDOS.length; index++) {
				let oContenido;
				try{
					oContenido = CONTENIDOS[index];
					const NODO_has_CONTENIDO = listaNODO_has_CONTENIDO[index].result;

					NODO_has_CONTENIDO.IdContenido = oContenido.Id;
					NODO_has_CONTENIDO.IdNodo = seccion.NODOS[0].Id;

					if (oContenido.X === 0 && oContenido.Y === 0) {
						oContenido.X = seccion.NODOS[0].X;
						oContenido.Y = seccion.NODOS[0].Y;
					}

					if (oContenido.Latitud === 0 && oContenido.Y === 0) {
						oContenido.Latitud = seccion.NODOS[0].Latitud;
						oContenido.Longitud = seccion.NODOS[0].Longitud;
					}

				}
				catch (error) {
					that.oContenidoErroneos.push(oContenido);
				}
			}

			return CONTENIDOS;
		});
	}

	obtenerALAS() {
		const includes = 'SECCIONS.NODOS, IDIOMAS, SECCIONS.IDIOMAS';
		return this.entityManager.getALA(undefined, includes)
		.then(function (entidades) {
			if (entidades == null || entidades.length < 1) {
				console.log('NO HAY ALAS');
			}
			else {
				return entidades;
			}
		})
		.catch(function(err){
			throw err;
		});
	}

	onRemoveSelectContenidos($event) {
		console.log('onRemoveSelect $event: ' + $event);
		console.log($event);
		// this.imagenSeleccionada = undefined;
	}

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/views/contenidos/contenidos.component.ts